import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import reactStringReplace from 'react-string-replace';
import Colors from '../styles/colors';

const LimitWarning = props => {
  const messages = reactStringReplace(props.message, /(upgrade)/gi, (match, i) => {
    return (
      <UpgradeLink key={`link-${i}`} onClick={props.onClickUpgrade}>
        {match}
      </UpgradeLink>
    );
  });

  return (
    <Warning>
      <div className="message-wrapper">
        <i className="material-icons">info</i>
        <span className="text-large padding-two-left padding-two-right">{messages}</span>
      </div>
    </Warning>
  );
};

const Warning = styled.div`
  display: flex;
  align-items: flex-start;
  padding: 15px;
  background-color: #fafafa;
  border: 1px dashed #eee;
  margin-bottom: 20px;
  font-weight: normal;

  .message-wrapper {
    display: flex;
    flex: 1 1 0%;
  }

  .btn {
    align-self: center;
  }
`;

const UpgradeLink = styled.span`
  color: ${Colors.mainOrange};
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

LimitWarning.propTypes = {
  message: PropTypes.string.isRequired,
  onClickUpgrade: PropTypes.func,
};

LimitWarning.defaultProps = {
  message: '',
  onClickUpgrade: () => {},
};

export default LimitWarning;
